import BigNumber from 'bignumber.js';
import { Market } from '#/api/markets';

/** Decimal places precision for base currency (e.g. BTC) */
export function baseCurrencyDecimalPlaces(market: Market): number {
  return getDecimalPlaces(market.order_size_increment);
}

/** Decimal places precision for quote currency (e.g. USD) */
export function quoteCurrencyDecimalPlaces(market: Market): number {
  return getDecimalPlaces(market.price_tick_size);
}

/** Format price in market's quote currency */
export function formatPrice(market: Market, price: BigNumber): string {
  return price.toFormat(priceDecimalPlaces(market, price));
}

/** Format size in market's base currency */
export function formatSize(market: Market, size: BigNumber): string {
  return size.toFormat(sizeDecimalPlaces(market, size));
}

function getDecimalPlaces(num: BigNumber, fallback = 0): number {
  return num.decimalPlaces() ?? fallback;
}

/** Decimal places for an order price (in market's quote currency) */
function priceDecimalPlaces(market: Market, price: BigNumber): number {
  // This prevents rounding the price to the market's quote currency
  // number of decimal places if price has more decimals
  return Math.max(getDecimalPlaces(price), quoteCurrencyDecimalPlaces(market));
}

/** Decimal places for an order size (in market's base currency) */
function sizeDecimalPlaces(market: Market, size: BigNumber): number {
  // This prevents rounding the size to the market's base currency
  // number of decimal places if size has more decimals
  return Math.max(getDecimalPlaces(size), baseCurrencyDecimalPlaces(market));
}
